import React, { useEffect, useRef } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import type { RootState } from '@/store/store';
import { clearCustomer, fetchCustomers } from '@/store/slices/customerSlice';
import { clearUser } from '@/store/slices/userSlice';
import localconfig from '@/config/local-config.json';
import { useSelection } from '@/hooks/useSelection';

interface CustomerProviderProps {
  children: React.ReactNode;
}

export const CustomerProvider: React.FC<CustomerProviderProps> = ({ children }) => {
  const dispatch = useAppDispatch();
  const { isAuthenticated, isLoading: authLoading, user: auth0User,
      getAccessTokenSilently
     } = useAuth0();
  const { data: userData } = useAppSelector((state) => state.user);
  const { data: customerData, loading: customerLoading, fetched, status } = useAppSelector(
    (state: RootState) => state.customer
  );
  const { setInitialLoad } = useSelection();

  // Use ref to track if fetch has been initiated
  const fetchInitiated = useRef(false);

  useEffect(() => {
    let cancelled = false;
    // console.log('CustomerProvider: setting initialload');
    dispatch(setInitialLoad(true));
    async function fetchCustomerData() {
        // Only fetch once when user data is available
        console.log('CustomerProvider: userData and fetched status', userData, fetched, fetchInitiated.current);
        if (userData && userData.id && !fetched && !fetchInitiated.current) {
            if (customerData) return;
            console.log('CustomerProvider: fetching customer data for user', userData.id);
            fetchInitiated.current = true;
            const accessToken = await getAccessTokenSilently();
            let accessTokenValue;
            if (import.meta.env.DEV) {
                // console.log('fetchUserInfo: using qa config for user info');
                accessTokenValue = localconfig.accessToken;
            } else {
                accessTokenValue = accessToken;
            }
            
            const action = await dispatch(
                fetchCustomers({userId: userData.id, accessToken: accessTokenValue})
            );
            // if (!cancelled && fetchCustomers.fulfilled.match(action)) {
            //     const apiUser = action.payload;
            //     console.log('CustomerProvider: fetched customer data', apiUser);
            // } else {
            //     console.error('CustomerProvider: failed to fetch customer data');
            //     dispatch(clearUser());
            // }
        } else {
            // dispatch(clearCustomer());
        }
    }
    fetchCustomerData();
    return () => {
      cancelled = true;
    };
    
  }, [userData, fetched, dispatch]);

  // Only show loading for initial load
//   if (userData && customerLoading && !customerData) {
//     return (
//       <div style={{ 
//         display: 'flex', 
//         justifyContent: 'center', 
//         alignItems: 'center', 
//         height: '100vh' 
//       }}>
//         Loading customer data...
//       </div>
//     );
//   }

  return <>{children}</>;
};